// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__QXtPd","left":"InfoRow_left__2sABA"};